class ShowroomsSearch {
  constructor(root) {
    this.root = root;
    this.form = root.querySelector(".showrooms-search-box");
    this.input = root.querySelector(".showrooms-search-input");
    this.items = Array.from(root.querySelectorAll(".showrooms-list .showroom-item"));

    if (this.form && this.input) this.init();
  }

  init() {
    this.form.addEventListener("submit", (event) => {
      event.preventDefault();
      this.search();
    });

    this.input.addEventListener("search", () => this.search());
  }

  normalize(value) {
    return String(value || "")
      .trim()
      .toLocaleLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/ł/g, "l")
      .replace(/\s+/g, " ");
  }

  search() {
    const query = this.normalize(this.input.value);
    const visibleIds = [];

    this.items.forEach((item) => {
      const name = this.normalize(item.dataset.name);
      const address = this.normalize(item.dataset.address);
      const isVisible = query === "" || name.includes(query) || address.includes(query);

      item.classList.toggle("hidden", !isVisible);
      item.setAttribute("aria-hidden", String(!isVisible));

      if (isVisible) visibleIds.push(Number(item.dataset.id));
    });

    this.root.dispatchEvent(
      new CustomEvent("showrooms:search", {
        detail: {
          query,
          visibleIds,
        },
      }),
    );
  }
}
